export enum EnumEnderecoTipo {
    COMERCIAL = 1,
    RESIDENCIAL = 2,
    FATURAMENTO = 3,
    ENTREGA = 4,
    COBRANCA = 5
}

export type TypeEnderecoTipo = {
    codigo?: number,
    tipo?: string
}

export type TypeEstado = {
    codigo?: number,
    codPais?: number,
    codIbge?: number,
    sigla?: string,
    nome?: string
}

export type TypeMunicipio = {
    codigo?: number,
    codMunicipio?: number,
    nome?: string,
    estado?: TypeEstado
}

export type TypeEndereco = {
    codigo?: number,

    tipo: TypeEnderecoTipo,
    estado: TypeEstado,
    municipio: TypeMunicipio,
    cep: string,
    logradouro: string,
    numero: string,
    bairro: string,
    complemento?: string,
    ativo?: boolean,

    distancia?: number
}

export type NoUndefinedState<T> =
    T extends [infer S | undefined, React.Dispatch<React.SetStateAction<infer S | undefined>>]
    ? [S, React.Dispatch<React.SetStateAction<S>>]
    : never;